import React, { useState } from 'react'
import ContentTemplate from '../../components/common/ContentTemplate'
import SubContentTemplate from '../../components/common/SubContentTemplate'
import PageHeaderContainer from '../../containers/common/PageHeaderContainer'
import PageTitleTemplate from '../../components/common/PageTitleTemplate'
import BreadcrumbContainer from '../../containers/common/BreadcrumbContainer'
import PageTemplate from '../../components/common/PageTemplate'
import { FUTURES_LEAGUE_RANKING_PITCHER, FUTURES_LEAGUE_TAB, FUTURES_LEAGUE_RANKING_TAB, FUTURES_LEAGUE_RANKING } from '../../constants/page'
import FuturesLeaguePitcherRankingContainer from '../../containers/game/FuturesLeaguePitcherRankingContainer'
import SecondContentTemplate from '../../components/common/SecondContentTemplate'
import FuturesLeaguePitcherRankingTableContainer from '../../containers/game/FuturesLeaguePitcherRankingTableContainer'


const FuturesLeaguePitcherRankingPage = ({ match }) => {

  // const currentPage = FUTURES_LEAGUE_RANKING_PITCHER

  FUTURES_LEAGUE_RANKING_TAB.forEach(tab => {
    tab.isActive = false
    if (match.path === tab.path) {
      tab.isActive = true
    }
  })

  const [year, setYear] = useState(null)

  return (
    <PageTemplate className="game">
      <PageHeaderContainer title="퓨처스 리그" subtitle="kt wiz의 투수 기록을 알려드립니다." image={require('../../assets/img/game/sub_tit_game.png')} forwardTabs={FUTURES_LEAGUE_TAB} currentPath={FUTURES_LEAGUE_RANKING.path} />
      <ContentTemplate className='game_rank_record'>
        <PageTitleTemplate>
          <BreadcrumbContainer page={FUTURES_LEAGUE_RANKING_PITCHER} />
        </PageTitleTemplate>
        <SubContentTemplate tabs={FUTURES_LEAGUE_RANKING_TAB}>
          <FuturesLeaguePitcherRankingContainer match={match} year={year} />
        </SubContentTemplate>
      </ContentTemplate>
      <SecondContentTemplate className='game'>
        <FuturesLeaguePitcherRankingTableContainer year={year} onChangeYear={setYear} />
      </SecondContentTemplate>
    </PageTemplate>
  )
}

export default FuturesLeaguePitcherRankingPage
